/* Copyright (c) 2018-2025, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { Types } from 'bridge-commands/types';

export enum IpcEvents {
    SelfUpdate = 'IPC_SELF_UPDATE_EVENT',
    RecommendedUpdate = 'IPC_RECOMMENDED_UPDATE_EVENT',
    RequiredUpdate = 'IPC_REQUIRED_UPDATE_EVENT',
    CriticalUpdate = 'IPC_CRITICAL_UPDATE_EVENT',
    PushNotification = 'IPC_PUSH_NOTIFICATION',
    LoginStatusChanged = 'IPC_LOGIN_STATUS_CHANGED_EVENT',
    CollectClientLogs = 'IPC_COLLECT_LOGS', // TODO: remove this later if not needed.
    UpdateExperimentContext = 'IPC_UPDATE_EXPERIMENT_CONTEXT',
    ProgressUpdate = 'IPC_PROGRESS_UPDATE',
    QueueEmpty = 'IPC_QUEUE_EMPTY',
    UploadExceptionInfo = 'IPC_UPLOAD_EXCEPTION_INFO',
    SelfUpdateStatus = 'IPC_GET_SELF_UPDATE_STATUS',
    UpdateCheckFailure = 'IPC_UPDATE_CHECK_FAILURE',
    DownloadPrepareFailure = 'IPC_DOWNLOAD_PREPARE_FAILURE',
    SelfUpdateThresholdNotReached = 'IPC_SELF_UPDATE_FAILURE_THRESHOLD_NOT_REACHED'
}

export enum IpcLogCollectionReason {
    ExceptionOccurred = 'ExceptionOccurred', // TODO: remove this later if not needed.
    UserFeedBack = 'UserFeedback',
    LoginFailure = 'LoginFailure'
}

export import IpcMessage = Types.Common.Ipc.IpcMessage;
export import IpcTargets = Types.Common.Ipc.IpcTargets;
